import { render, staticRenderFns } from "./SpaceSummary.vue?vue&type=template&id=5a6390f2"
import script from "./SpaceSummary.vue?vue&type=script&lang=js"
export * from "./SpaceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports